module.exports = __webpack_public_path__ + "img/captures.1875484.png";